import { Component, effect, inject, Signal, ChangeDetectionStrategy } from '@angular/core';
import { AuthFacade } from '@iot-platform/auth';
import { ApiInterceptorService } from '@iot-platform/core';
import { UserPreferences } from '@iot-platform/models/common';
import { PreferencesFacade, UserProfileService } from '@iot-platform/data-access/users';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet />
    <iot-platform-notification [isLoggedOut]="selectLoggedOut()" />
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppComponent {
  protected readonly authFacade: AuthFacade = inject(AuthFacade);
  selectLoggedOut = this.authFacade.isLoggedOut;
  protected readonly preferencesFacade: PreferencesFacade = inject(PreferencesFacade);
  preferences: Signal<UserPreferences> = this.preferencesFacade.preferences;
  protected readonly userProfileService: UserProfileService = inject(UserProfileService);
  protected readonly apiInterceptorService: ApiInterceptorService = inject(ApiInterceptorService);

  constructor() {
    this.apiInterceptorService.setBuildInfo();

    effect(() => {
      const preferences = this.preferences();
      if (preferences) {
        this.userProfileService.setThemeOverlay();
        this.preferencesFacade.setLanguage(preferences.appLanguage);
      }
    });
  }
}
